import globalConfig from 'Helper/configHelpers'
import Store from '../store'
import { setScreen } from 'actions/interactableActions.js'
import _ from 'lodash'

export const reconstructRoute = (
  params = {},
  replaceParams = {},
  route = ''
) => {
  if (route.indexOf('/patient/') !== -1) {
    route = reconstructPatientRoute(params, replaceParams)
  } else if (route.indexOf('/admin') !== -1) {
    route = reconstructAdminRoute(params, replaceParams)
  }
  return route
}

const paramFixer = (params, replaceParams) => {
  const adjustedReplacementParams = {}
  Object.keys(replaceParams).forEach(param => {
    if (param === 'screen' || param === 'workflow' || param === 'step') {
      adjustedReplacementParams[param] = replaceParams[param]
    } else if (param.indexOf('Id') === param.length - 2) {
      const newParam = param.substring(0, param.length - 2)
      adjustedReplacementParams[newParam] = replaceParams[param]
    } else {
      adjustedReplacementParams[param] = replaceParams[param]
    }
  })
  return { ...params, ...adjustedReplacementParams }
}

const reconstructAdminRoute = (params = {}, replaceParams = {}) => {
  // this takes in a new route (hopefully without any of the route params!)
  // and appends the current params to the new route
  const newParams = paramFixer(params, replaceParams)
  let route
  if (newParams.workflow != null) {
    route = `${globalConfig.basepath}dashboard/admin/workflow/${newParams.workflow}`
    if (newParams.step != null) {
      route = `${route}/step/${newParams.step}`
    }
  } else if (newParams.screen != null) {
    route = `${globalConfig.basepath}dashboard/admin/screen/${newParams.screen}`
  } else {
    route = `${globalConfig.basepath}dashboard/admin`
  }
  return route
}

export const reconstructPatientRoute = (params = {}, replaceParams = {}) => {
  // this takes in a new route (hopefully without any of the route params!)
  // and appends the current params to the new route
  const newParams = paramFixer(params, replaceParams)

  let route
  if (newParams.workflow != null) {
    route = `${globalConfig.basepath}dashboard/patient/${newParams.patientId}/workflow/${newParams.workflow}`
    if (newParams.step != null) {
      route = `${route}/step/${newParams.step}`
    }
  } else if (newParams.screen != null) {
    route = `${globalConfig.basepath}dashboard/patient/${newParams.patientId}/screen/${newParams.screen}`
  } else {
    route = `${globalConfig.basepath}dashboard/patient/${newParams.patientId}`
  }
  return route
}
/* save below */

export const push = (route, leaveWindowsOpen) => {
  route = safeURIEncode(route)
  if (leaveWindowsOpen === undefined) {
    leaveWindowsOpen = !isContextChange(route)
  }
  if (route.indexOf(globalConfig.basepath) !== 0) {
    route = (globalConfig.basepath + route).replace('//', '/')
  }
  if (!leaveWindowsOpen) {
    // close all open windows before push
    Store.dispatch(setScreen([]))
  }
  globalConfig.navigate(route)
}

export const contextToPath = (context) => {
  switch (context) {
    case 'nurseDashboard':
      return 'dashboard'
    case 'adminDisplay':
      return 'dashboard/admin'
    case 'patientDisplay':
      // this cant actually work because we dont know the patient id?
      return 'dashboard/patient'
    case 'configDisplay':
      return 'config'
    default:
      // hopefully they gave us an actual path instead of a context here.
      // either way, we know we don't want leading and trailing slashes so remove them if present
      return _.trim(context,'/')
  }
}

export const getContextName = (path) => {
  if (path.startsWith(`${globalConfig.basepath}dashboard/admin`)) {
    return 'adminDisplay'
  } else if (path.startsWith(`${globalConfig.basepath}dashboard/patient`)) {
    return 'patientDisplay'
  } else if (
    path.startsWith(`${globalConfig.basepath}dashboard/screen`) ||
          path === `${globalConfig.basepath}dashboard` ||
          path === `${globalConfig.basepath}dashboard/`) {
    return 'nurseDashboard'
  } else if (path.startsWith(`${globalConfig.basepath}config/`) ||
    path === `${globalConfig.basepath}config`) {
    return 'configDisplay'
  }
}

const patientIdFromPath = path => {
  // note, this isn't looking for patient_id anywhere. This is highly specific to our application
  // and the fact that any UI route that includes patient id is always in the format of:
  // dashboard/patient/{id}
  const prefix = 'dashboard/patient/'
  const startPatientId = path.indexOf(prefix)
  if(startPatientId === -1) {
    // we aren't even on a patient path
    return null
  }
  const idAndRest = path.substring(startPatientId + prefix.length)
  const endPatientId = idAndRest.indexOf('/') === -1 ? idAndRest.length : idAndRest.indexOf('/')
  return idAndRest.substring(0, endPatientId)
}

export const isContextChange = (pathA, router = null) => {
  if (router == null) {
    const state = Store.getState()
    router = state.router
  }
  const pathB = router.location.pathname
  if (pathA.includes('dashboard/admin') && pathB.includes('dashboard/admin')) {
    // not leaving admin display
    return false
  } else if (
    pathA.includes('dashboard/patient/') &&
    pathB.includes('dashboard/patient/')
  ) {
    const patientIdA = patientIdFromPath(pathA)
    const patientIdB = patientIdFromPath(pathB)
    return patientIdA !== patientIdB
  } else if (
    (pathA.includes('dashboard/screen') ||
      pathA.endsWith('dashboard') ||
      pathA.endsWith('dashboard/')) &&
    (pathB.includes('dashboard/screen') ||
      pathB.endsWith('dashboard') ||
      pathB.endsWith('dashboard/'))
  ) {
    // not leaving dashboard
    return false
  } else {
    // they are moving between contexts
    return true
  }
}

export const isPatientChange = (pathA, router = null) => {
  if (router == null) {
    const state = Store.getState()
    router = state.router
  }
  const pathB = router.location.pathname

  if (
    !pathA.includes('dashboard/patient') ||
    !pathB.includes('dashboard/patient')
  ) {
    return false
  }

  try {
    // if we are staying in patient context, attempt to see if the patient id has changed. if ids are the same, context is the same
    // if ids change, treat it as a context change
    return pathA.split('dashboard/patient')[1].split('/')[1] != pathB.split('dashboard/patient')[1].split('/')[1]
  } catch {
    // if we somehow failed comparing patient ids, we know we are still in patient context before and after so the safest thing is
    // to assume they are different patients and treat it as a context change.
    return true
  }
}

// the path will be embedded in the app URL so we need to make sure that things like
// spaces are properly encoded and decoded. the path portion will be saved to the database
// in encoded form so we will use decodeURIs to make them human redable as soon as we load them
// in to "screens" state and we will use encodeURIComponents to re-encode them just before sending them
// to the api
export const decodeItemURIComponents = item => {
  if(item.path) {
    item.path = decodeURIComponent(item.path)
  }
  return item
}

export const encodeItemURIComponents = item => {
  if(item.path && !isURIComponentEncoded(item.path)) { // prevent double encoding
    item.path = encodeURIComponent(item.path)
  }
  return item
}

export const isURIComponentEncoded = uri => {
  return uri === decodeURIComponent(uri || '')
}

export const isURIEncoded = uri => {
  return uri === decodeURI(uri || '')
}

export const safeURIEncode = uri => {
  return isURIEncoded(uri) ? uri : encodeURI(uri)
}